module.exports = __webpack_public_path__ + "img/user-solid.a8dc4d4e.svg";